import * as types from "../constants/actionConstants";
import * as portalShared from "../portal/shared/metadataConstantsAndUtilities"

const initialState = {
    drawerStack: [],
    displayTitle: ""
};

export default function drawerStackReducer(state = initialState, action) {
    switch (action.type) {
        case types.ADD_DRAWER_NAME: {
            let tempState = portalShared.cloneObj(state)
            tempState.drawerStack.push(action.drawer)
            tempState.displayTitle = createTitle(tempState.drawerStack)
            return tempState;
        }
        case types.REMOVE_DRAWER_NAME: {
            let tempState = portalShared.cloneObj(state)
            tempState.drawerStack.pop()
            tempState.displayTitle = createTitle(tempState.drawerStack)
            return tempState;
        }
        default:
            return state;
    }
}

const createTitle = (drawerStack) => {
    let title = ""
    drawerStack.forEach((drawer, i) => {
        if (i === 0) title += `${drawer.mode} ${drawer.drawerName}`
        else if (drawerStack[i-1].mode !== drawer.mode) title += ` -> ${drawer.mode} ${drawer.drawerName}`
        else title += ` -> ${drawer.drawerName}`
    })
    return title
};